import { render, staticRenderFns } from "./SelecaoEntesFederativos.vue?vue&type=template&id=7973e471&scoped=true"
import script from "./SelecaoEntesFederativos.vue?vue&type=script&lang=js"
export * from "./SelecaoEntesFederativos.vue?vue&type=script&lang=js"
import style0 from "./SelecaoEntesFederativos.vue?vue&type=style&index=0&id=7973e471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973e471",
  null
  
)

export default component.exports